<template>
  <div v-if="rawValue !== null">
    <template v-if="parsedFloat > 0">
      <Icon :title="rawValue"
            class="green pt-2 left"
            name="arrow-up16"></Icon>
      <span class="right">+{{ rawValue }}</span>
    </template>
    <template v-else>
      <Icon :title="rawValue"
            class="red pt-2 left"
            name="arrow-down16"></Icon>
      <span class="right">{{ rawValue }}</span>
    </template>
  </div>
</template>

<script>
  import Icon from '../../../common/layout/Icon.vue';

  export default {
    name: 'DeviationRatedActual',
    compatConfig: {
      MODE: 3,
    },
    components: {
      Icon,
    },
    data() {
      return {
        rawValue: null,
        parsedFloat: undefined,
      };
    },
    beforeMount() {
      this.rawValue = this.params.value ?? null;

      if (this.rawValue !== null) {
        this.parsedFloat = parseFloat(this.rawValue.replace(',', '.'));
      }
    },
  };
</script>
